module.exports = __webpack_public_path__ + "media/images/emblems/Ochlenberg-coat_of_arms-71649e724b015040e7138d9c58d05213.svg";